import { Tab, Tabs } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const TabStyled = styled(Tab)(({ theme }) => ({
  fontFamily: 'montserrat',
  color: theme.palette.global.gray,
  cursor: 'pointer',
  fontSize: '12px',
  fontWeight: 'bold',
  backgroundColor: 'transparent',
  width: '100%',
  height: 54,
  padding: '12px 16px',
  border: 'none',
  borderRadius: '5px',
  gap: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.7),
    color: theme.palette.global.white,
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  '&:focus': {
    color: '#fff',
    borderRadius: 3,
    backgroundColor: theme.palette.primary.main,
    outlineOffset: 2,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.global.white,
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  '&.focusVisible': {
    color: '#fff',
    outline: 'none',
    backgroundColor: alpha(theme.palette.primary.main, 0.6),
  },
  '&:disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  '& svg': {
    '@media(max-width: 1080px)': {
      fontSize: 16,
    },
  },
  '& p': {
    '@media(max-width: 1080px)': {
      fontSize: 13,
    },
    fontWeight: 600,
  },
}));

export const TabPanelStyled = styled('div')({
  width: '100%',
  fontSize: '0.875rem',
  fontFamily: 'montserrat',
});

export const TabListStyled = styled(Tabs)(({ theme }) => ({
  minWidth: 320,
  backgroundColor: alpha(theme.palette.global.lightgray, 0.3),
  borderTopRightRadius: 3,
  borderTopLeftRadius: 3,
  marginBottom: 12,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  alignContent: 'space-between',
  maxWidth: '100%',
}));
